<template>
  <q-dialog v-model="isOpenSync">
    <q-card>
      <q-card-section>
        <h5 class="text-positive">Verify confirm</h5>
      </q-card-section>

      <q-card-section>
        <p>Are you sure you want to verify this transporter?</p>

        <p v-if="error" class="text-negative text-body2">{{ error }}</p>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn v-close-popup color="muted" flat label="cancel" :disable="loading" />

        <q-btn unelevated color="primary" label="Confirm" :loading="loading" @click="verifyUser" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { getErrorMessage } from '@/utils';

export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    transporterId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      error: '',
    };
  },

  computed: {
    isOpenSync: {
      get() {
        return this.isOpen;
      },

      set(value) {
        this.$emit('update:isOpen', value);
      },
    },
  },

  methods: {
    async verifyUser() {
      try {
        this.error = '';
        this.loading = true;

        await this.$axios.patch(`/admin/transporter/${this.transporterId}/verify`, {
          status: 'verified',
        });

        this.$emit('verify-success');
      } catch (error) {
        this.error = getErrorMessage(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style></style>
